import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FcpBadgeColor, FcpIcon } from 'fc-ui-components';

@Component({
    selector: 'fc-faux-input-button',
    templateUrl: './faux-input-button.component.html',
    styleUrls: ['./faux-input-button.component.less'],
    standalone: false
})
export class FauxInputButtonComponent {
    @Input() text: string;
    @Input() icon?: FcpIcon;
    @Input() badge?: FauxInputButtonBadge;
    @Output() clicked = new EventEmitter<MouseEvent>();

    onClickHandler(event: MouseEvent) {
        this.clicked.emit(event);
    }
}

export type FauxInputButtonBadge = {
    text: string;
    color: `${FcpBadgeColor}`;
};
